let refreshing = false;
const CURRENT_BUILD = process.env.REACT_APP_RUN_NUMBER || '';
const VERSION_CHECK_INTERVAL_MS = 60 * 1000;

export function applyServiceWorkerUpdate(registration) {
  if (registration?.waiting) {
    registration.waiting.postMessage({ type: 'SKIP_WAITING' });
  }
}

async function enforceLatestBuild() {
  if (!CURRENT_BUILD || refreshing) return;

  try {
    const versionUrl = `${process.env.PUBLIC_URL || ''}/pwa-version.json?t=${Date.now()}`;
    const response = await fetch(versionUrl, { cache: 'no-store' });
    if (!response.ok) return;

    const deployedVersion = String((await response.json()).build || '');
    if (deployedVersion && deployedVersion !== CURRENT_BUILD) {
      refreshing = true;
      window.location.reload();
    }
  } catch (error) {
    // A temporary network failure must not interrupt the current session.
  }
}

export function registerServiceWorker() {
  if (process.env.NODE_ENV !== 'production' || !('serviceWorker' in navigator)) {
    return;
  }

  navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (refreshing) {
      return;
    }

    refreshing = true;
    window.location.reload();
  });

  window.addEventListener('load', () => {
    const publicUrl = new URL(process.env.PUBLIC_URL || '/', window.location.href);

    if (publicUrl.origin !== window.location.origin) {
      return;
    }

    const serviceWorkerUrl = `${process.env.PUBLIC_URL}/service-worker.js`;

    navigator.serviceWorker
      .register(serviceWorkerUrl)
      .then((registration) => {
        if (registration.waiting) {
          applyServiceWorkerUpdate(registration);
        }

        registration.addEventListener('updatefound', () => {
          const installingWorker = registration.installing;

          if (!installingWorker) {
            return;
          }

          installingWorker.addEventListener('statechange', () => {
            if (installingWorker.state === 'installed' && navigator.serviceWorker.controller) {
              applyServiceWorkerUpdate(registration);
            }
          });
        });

        registration.update().catch(() => {});
        enforceLatestBuild();
        window.setInterval(() => {
          registration.update().catch(() => {});
          enforceLatestBuild();
        }, VERSION_CHECK_INTERVAL_MS);

        document.addEventListener('visibilitychange', () => {
          if (document.visibilityState === 'visible') {
            registration.update().catch(() => {});
            enforceLatestBuild();
          }
        });

        window.addEventListener('online', enforceLatestBuild);
      })
      .catch((error) => {
        console.error('Service worker registration failed:', error);
      });
  });
}
